<template>
  <div id="Part03" ref="page">
    <bg-video v-if="!showDetail" filename="Part03" autoplay canskip @ended="handleEnded"/>

    <template v-if="showDetail">
      <div class="top-nav">
        <img src="../../assets/wiki/img/logo.png" alt="知识魔方">
      </div>
      <template v-if="!dialogVisiable">
        <section class="pos-c">
          <div class="tech-container">
            <ul class="tech-list" :style="{ width: `${col * 2.2}rem` }">
              <li
                v-for="(d, i) in filteredData"
                :key="i"
                class="out-right"
                @mouseenter="handleMouseEnter"
                @mouseleave="handleMouseLeave"
                @click="showDialog(d, i)"
              >
                <div v-if="isIe" class="ie-box">
                  <img :src="require(`../../assets${d.cover}`)">
                  <div class="mask"/>
                  <div class="text-wrap">
                    <h3 class="pos-c">{{ d.question }}</h3>
                  </div>
                </div>
                <div v-else class="picBox">
                  <div class="show">
                    <img :src="require(`../../assets${d.cover}`)">
                  </div>
                  <div class="hide">
                    <h3 class="pos-c">{{ d.question }}</h3>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <left v-show="index > 0" @click="index -= 1"/>
          <right v-show="index < data.length / size - 1" @click="index += 1"/>
        </section>
        <guide-button class="btn-lt" @click="$router.push('/TitlePage/02')">返回</guide-button>
        <guide-button class="btn-rt" @click="$router.push('/TitlePage/04')">继续</guide-button>
      </template>
      <transition name="fade">
        <card v-if="dialogVisiable" :item="item" @close="closeDialog" @play-audio="playAuido" @pause-audio="audio.pause()"/>
      </transition>
    </template>
  </div>
</template>

<script>
import data from './data.js'
import Card from './Card'

export default {
  name: 'Part03',
  components: {
    Card,
  },
  data () {
    return {
      dialogVisiable: false,
      showDetail: false,
      data: data,
      index: 0,
      col: 6,
      row: 3,
      item: {},
      audio: document.createElement('AUDIO'),
    }
  },
  computed: {
    size () {
      return this.row * this.col
    },
    filteredData () {
      return this.data.slice(this.index * this.size, (this.index + 1) * this.size)
    },
    isIe () {
      return !!window.ActiveXObject || 'ActiveXObject' in window
    },
  },
  beforeDestroy () {
    this.audio.pause()
  },
  methods: {
    handleEnded () {
      this.showDetail = true
      this.playAuido('/wiki/audio/bg.mp3', true)
    },
    playAuido (src, loop = false) {
      this.audio.loop = loop
      if (!this.audio.src.endsWith(src)) {
        this.audio.src = require(`../../assets${src}`)
      }
      this.audio.play()
    },
    showDialog (item) {
      if (item.narrate) {
        this.playAuido(`/wiki/audio/${item.narrate}.mp3`)
      }
      this.item = item
      this.dialogVisiable = true
    },
    closeDialog () {
      this.dialogVisiable = false
      this.playAuido('/wiki/audio/bg.mp3', true)
    },
    _getDirection (event) {
      const rect = event.target.getBoundingClientRect()
      const x = event.pageX - rect.x // (得到鼠标在框中的坐标)
      const y = event.pageY - rect.y // (得到鼠标在框中的坐标)
      const H = event.target.clientHeight
      const W = event.target.clientWidth
      const k = Math.floor(H / W) // 为了防止不能整除
      if (k * x >= y && H - k * x >= y) {
        // 这是判断从上方进入,这边简化处理不对等于情况做特别处理
        return 'top'
      }
      if (k * x < y && H - k * x < y) {
        return 'bottom'
      }
      if (k * x < y && H - k * x > y) {
        return 'left'
      }
      if (k * x > y && H - k * x < y) {
        return 'right'
      }
    },
    handleMouseEnter (event) {
      event.target.className = `in-${this._getDirection(event)}`
    },
    handleMouseLeave (event) {
      event.target.className = `out-${this._getDirection(event)}`
    },
  },
}
</script>

<style lang="scss" scoped>
#Part03 {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-image: url(../../assets/wiki/img/bg.jpg);
  background-size: 100%;
  transition: all 0.3s ease;
  .top-nav {
    position: relative;
    top: 0.8rem;
    text-align: center;
    img {
      width: 9.6rem;
    }
  }

  .left,
  .right {
    top: 50%;
    width: 0.55rem;
    height: 1rem;
    margin-top: -0.5rem;
  }
  .left {
    left: -1rem;
  }
  .right {
    right: -1rem;
  }
}
.tech-container {
  position: relative;
  line-height: 0;
  .tech-list {
    margin: 0 auto;
    padding: 0;
    text-align: center;
    box-sizing: border-box;
  }
  li {
    position: relative;
    display: inline-block;
    width: 2rem;
    height: 2rem;
    margin: 0.1rem;
    list-style: none;
    perspective: 100%;
  }
  .ie-box {
    position: relative;
    height: 100%;
    overflow: hidden;
    cursor: pointer;
    img,
    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    .mask {
      background-color: rgba($color: #16abdd, $alpha: 0.8);
      transition: all 0.3s;
      opacity: 0;
    }
    .text-wrap {
      position: absolute;
      top: -2rem;
      left: 0;
      width: 100%;
      height: 100%;
      color: #fff;
      transition: all 0.5s;
      cursor: pointer;
      h3 {
        width: 1.8rem;
        padding: 0.1rem;
        font-size: 0.21rem;
        line-height: 1.5;
        font-weight: normal;
      }
    }
    &:hover {
      .mask {
        opacity: 1;
      }
      .text-wrap {
        top: 0;
      }
    }
  }
  .picBox {
    height: 100%;
    transform-style: preserve-3d;
    transform-origin: 50% 50% -1rem;
    animation: 200ms ease-out 0ms 1 normal forwards;
    .show,
    .hide {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 101;
    }
    .show {
      img {
        width: 100%;
        height: 100%;
      }
    }
    .hide {
      color: #fff;
      background-color: #1ab7ea;
      transform: translate3d(0, 0, -0.01rem);
      cursor: pointer;
      h3 {
        width: 1.8rem;
        padding: 0.1rem;
        font-size: 0.21rem;
        line-height: 1.5;
        font-weight: normal;
      }
    }
  }
  .in-top .hide,
  .out-top .hide {
    transform-origin: 0% 100%;
    transform: translate3d(0, -100%, 0) rotate3d(1, 0, 0, 90deg);
  }
  .in-top .picBox {
    animation-name: in-top;
    animation-play-state: running;
  }
  .out-top .picBox {
    animation-name: out-top;
    animation-play-state: running;
  }

  .in-right .hide,
  .out-right .hide {
    transform-origin: 0% 0%;
    transform: translate3d(100%, 0, 0) rotate3d(0, 1, 0, 90deg);
  }
  .in-right .picBox {
    animation-name: in-right;
    animation-play-state: running;
  }
  .out-right .picBox {
    animation-name: out-right;
    animation-play-state: running;
  }
  .in-bottom .hide,
  .out-bottom .hide {
    transform-origin: 0% 0%;
    transform: translate3d(0, 100%, 0) rotate3d(-1, 0, 0, 90deg);
  }
  .in-bottom .picBox {
    animation-name: in-bottom;
    animation-play-state: running;
  }
  .out-bottom .picBox {
    animation-name: out-bottom;
    animation-play-state: running;
  }
  .in-left .hide,
  .out-left .hide {
    transform-origin: 100% 0;
    transform: translate3d(-100%, 0, 0) rotate3d(0, -1, 0, 90deg);
  }
  .in-left .picBox {
    animation-name: in-left;
    animation-play-state: running;
  }
  .out-left .picBox {
    animation-name: out-left;
    animation-play-state: running;
  }
}

@keyframes in-top {
  from { transform: rotate3d(0, 0, 0, 0deg); }
  to { transform: rotate3d(-1, 0, 0, 90deg); }
}

@keyframes out-top {
  from { transform: rotate3d(-1, 0, 0, 90deg); }
  to { transform: rotate3d(0, 0, 0, 0deg); }
}

@keyframes in-right {
  from { transform: rotate3d(0, 0, 0, 0deg); }
  to { transform: rotate3d(0, -1, 0, 90deg); }
}

@keyframes out-right {
  from { transform: rotate3d(0, -1, 0, 90deg); }
  to { transform: rotate3d(0, 0, 0, 0deg); }
}

@keyframes in-bottom {
  from { transform: rotate3d(0, 0, 0, 0deg); }
  to { transform: rotate3d(1, 0, 0, 90deg); }
}
@keyframes out-bottom {
  from { transform: rotate3d(1, 0, 0, 90deg); }
  to { transform: rotate3d(0, 0, 0, 0deg); }
}

@keyframes in-left {
  from { transform: rotate3d(0, 0, 0, 0deg); }
  to { transform: rotate3d(0, 1, 0, 90deg); }
}
@keyframes out-left {
  from { transform: rotate3d(0, 1, 0, 90deg); }
  to { transform: rotate3d(0, 0, 0, 0deg); }
}
</style>
